import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { IMenuEntity, IMenuList, MenuService } from '../menu.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTreeModule } from '@angular/material/tree';

// NOTE: Lib
import { IMenuFooterEntity, LibFooterComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { ROUTER_TOKENS } from '../../app.routes';
import { IProductSearchOptions } from '@web-nx-ng-tsc/web-shared-data-access';
import { tap, map, forkJoin, switchMap } from 'rxjs';
import { ICategory, LS } from '@web-nx-ng-tsc/data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { MetaService } from '@web-nx-ng-tsc/util-meta';
// Define Icon menu
const MENU_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;

@Component({
  selector: 'app-main-layout',
  imports: [
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatTreeModule,
    LibFooterComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private readonly menuService = inject(MenuService);
  private readonly router = inject(Router);
  private readonly loggingService = inject(LoggingService);
  private readonly metaService = inject(MetaService);

  menuList = this.menuService.menuList;
  footerList = this.menuService.footerList;
  footerlength = signal<number>(0);
  categoryList = signal<ICategory[]>([]);
  childrenAccessor = (node: IMenuList) => node.submenu ?? [];
  hasChild = (_: number, node: IMenuList) => !!node.submenu && node.submenu.length > 0;

  constructor() {
    this.loggingService.warn('@@@ Menu Component @@@ ==>', this.menuService.menuList());
    this.registerIcon();
    this.getMenu();
    this.getFooter();
    this.onSetOpenGraphTags();
  }

  registerIcon() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIconLiteral('menu-svg', sanitizer.bypassSecurityTrustHtml(MENU_ICON));
  }

  handleClick(menuAtt: IMenuEntity, i?: number) {
    this.loggingService.log('menu', menuAtt);

    if (menuAtt.isCategory) {
      this.loggingService.log('if --- menuAtt.isCategory');

      const categoryAtt = this.categoryList().find((item) => item.name === menuAtt.title) as ICategory;
      this.menuService.setStorage(LS.categoryState, categoryAtt);
    }

    if (menuAtt.isRoute) {
      this.loggingService.log('if --- menuAtt.isRoute');

      if (menuAtt.url == '') {
        this.loggingService.log('if --- menuAtt.isRoute if', menuAtt);
        this.loggingService.log('if --- menuAtt.isRoute if', i);
        this.menuService
          .getSubMenuIDTire(menuAtt.title)
          .pipe(
            map((res: any) => res.id),
            tap((res) => {
              this.loggingService.log('GET | handleClick[API] :', res);
              this.router.navigateByUrl(`${ROUTER_TOKENS.PRODUCTS}/1/model/detail/${res}`);
              //bug mobile ต้องกด f5 ถึงจะเห็นข้อมูล แต่ path ถูกแล้ว
            })
          )
          .subscribe();
      } else {
        this.router.navigateByUrl(menuAtt.url);
      }
    }

    if (menuAtt.title && menuAtt.isRoute === false && menuAtt.isCategory == true) {
      this.loggingService.log('if --- menuAtt.title if');

      this.loggingService.log('handleClick', menuAtt);
      this.menuService
        .getSubMenuIDTire(menuAtt.title)
        .pipe(
          map((res: any) => res.id),
          tap((res) => {
            this.loggingService.log('GET | handleClick[API] :', res);
            this.router.navigateByUrl(`${ROUTER_TOKENS.PRODUCTS}/1/model/detail/${res}`);
          })
        )
        .subscribe();
    }
    //new tab for EV
    else if (!menuAtt.isCategory && !menuAtt.isRoute) {
      this.loggingService.log('if --- else');
      window.open(menuAtt.url);
    }
  }

  handleClickFooter(menuAtt: IMenuFooterEntity) {
    this.loggingService.log('menu', menuAtt);

    if (menuAtt.isCategory) {
      this.loggingService.log('menu', menuAtt.isCategory);

      const categoryAtt = this.categoryList().find((item) => item.name === menuAtt.label) as ICategory;
      this.menuService.setStorage(LS.categoryState, categoryAtt);
    }
    if (menuAtt.newTab) {
      this.loggingService.log('menu', menuAtt.newTab);

      window.open(menuAtt.url);
    } else {
      this.router.navigateByUrl(menuAtt.url);
    }
  }

  getMenu() {
    this.menuService
      .getMenu()
      .pipe(
        tap((res) => this.loggingService.log('GET | getMenuProduct[API] :', res)),
        map((res: any) => res.rows),
        map((res: any[]) => {
          this.categoryList.set(res); //Set categoryList
          return res.map((item) => ({
            isRoute: true,
            title: item.name,
            url: `${ROUTER_TOKENS.PRODUCTS}/${item.id}/list`,
            isCategory: true,
          }));
        }),
        tap((subMenu) => {
          this.loggingService.log('Processed SubMenu:', subMenu);

          // อัปเดตค่าใน signal
          this.menuList.update((menuList: any) => {
            return menuList.map((menu: any) => {
              if (menu.title === 'สินค้า') {
                return { ...menu, submenu: subMenu };
              }
              return menu;
            });
          });
        })
      )
      .subscribe();

    // this.menuService
    //   .getSubMenuTire()
    //   .pipe(
    //     tap((res) => this.loggingService.log('GET | getSubMenuTire[API] :', res)),
    //     map((res: any) => res.rows),
    //     map((res: any[]) => {
    //       return res.map((item) => ({
    //         isRoute: false,
    //         title: item.value, // ใช้ value เป็นชื่อเมนู
    //         // url: '',
    //         isCategory: true,
    //       }));
    //     }),
    //     tap((subMenu) => {
    //       this.loggingService.log('Processed SubMenu รุ่นยาง:', subMenu);
    //       this.menuList.update((menuList: any) => {
    //         return menuList.map((menu: any) => {
    //           if (menu.title === 'รุ่นยาง') {
    //             return { ...menu, submenu: subMenu };
    //           }
    //           return menu;
    //         });
    //       });
    //     })
    //   )
    //   .subscribe();

    const option: IProductSearchOptions = {
      // brand: '4', // ID brand 4 = nankang
    };

    this.menuService
      .getSubMenuModelTire('type', option)
      .pipe(
        tap((res) => this.loggingService.log('GET | getSubMenuTire[API] :', res)),
        map((res: any) => res.rows),
        switchMap((types: any[]) => {
          const subMenuRequests = types.map((type) => {
            const optionWithType = { ...option, type: type.value }; // เพื่อ types ใน option
            return this.menuService.getSubMenuModelTire('model', optionWithType).pipe(
              tap((res) => this.loggingService.log('GET | getSubMenuTireIn[API] :', res)),
              map((models: any) => {
                const modelList = Array.isArray(models) ? models : models?.rows ?? [];

                return {
                  title: type.value,
                  url: '',
                  isRoute: true,
                  submenu: modelList.map((model: any) => ({
                    title: model.value,
                    url: '',
                    isRoute: true,
                    parentTitle: type.value,
                  })),
                };
              })
            );
          });
          return forkJoin(subMenuRequests);
        }),
        tap((subMenu) => {
          this.loggingService.log(' getSubMenuTireBrand subMenu:', subMenu);
          this.menuList.update((menuList: any[]) => {
            return menuList.map((menu) => {
              if (menu.title === 'รุ่นยาง') {
                this.loggingService.log(' getSubMenuTireBrand subMenu:รุ่นยาง', menu);
                this.loggingService.log(' getSubMenuTireBrand subMenu:รุ่นยาง', menu);
                this.loggingService.log(' getSubMenuTireBrand subMenu:รุ่นยาง', subMenu);
                // this.loggingService.log('🟢 กำลังแทนที่เมนูรุ่นยาง:', subMenu);
                return {
                  ...menu,
                  submenu: subMenu, // 👈 อัปเดต submenu เฉพาะจุดนี้
                };
              }
              return menu;
            });
          });
        }),
        tap(() => {
          this.loggingService.log('🟢 menuList อัปเดตแล้ว:', this.menuList());
        })
      )
      .subscribe();
    this.loggingService.log(' getSubMenuTireBrand subMenu:', this.menuList());
  }
  getFooter() {
    this.menuService
      .getMenu()
      .pipe(
        tap((res) => this.loggingService.log('GET | getFooter :', res)),
        map((res: any) => res.rows),
        map((res: any[]) =>
          res.map((item) => ({
            label: item.name, // ใช้ label แทน title
            url: `${ROUTER_TOKENS.PRODUCTS}/${item.id}/list`,
            newTab: false,
            isCategory: true,
          }))
        ),
        tap((subMenu: any) => {
          this.loggingService.log('getFooter Processed SubMenu:', subMenu);
          this.loggingService.log('getFooter BEFORE UPDATE footerList:', this.footerList());

          // ✅ อัปเดต menu ใน footerList (ไม่ใช้ map กับ Object)
          this.footerList.update((footerList: any) => {
            return {
              ...footerList, // คงค่าอื่นไว้
              menu: footerList.menu.map((menu: any) => {
                if (menu.header === 'สินค้าและบริการ') {
                  this.footerlength.set(subMenu.length);

                  this.loggingService.log('getFooter:', {
                    ...menu,
                    menu: [...subMenu, ...menu.menu], // **เพิ่ม SubMenu API ไว้หน้าสุด**
                  });
                  return {
                    ...menu,
                    menu: [...subMenu, ...menu.menu], // **เพิ่ม SubMenu API ไว้หน้าสุด**
                  };
                }
                return menu;
              }),
            };
          });

          this.loggingService.log('AFTER UPDATE footerList:', this.footerList());
        })
      )
      .subscribe();
  }

  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'SAMSON TYRE Thailand | Samson Tyre ยางรถเก๋ง กระบะ และ SUV | Power Within',
      description:
        'ยางแซมซั่น Samson Tyre ครบ 7 รุ่น 62 ขนาด เลือกให้เหมาะกับรถและการขับขี่ของคุณ พร้อมประกันอุบัติเหตุ 180 วัน และประกันคุณภาพ 5 ปี ตามเงื่อนไขบริษัทฯ | SAMSON TYRE Thailand',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo-nankang_result-20250819114138.webp',
    });
  }
}
